import { render, staticRenderFns } from "./Conexiones.vue?vue&type=template&id=2a8ed474&scoped=true"
import script from "./Conexiones.vue?vue&type=script&lang=js"
export * from "./Conexiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ed474",
  null
  
)

export default component.exports